Drupal.behaviors.klaroConsentsToDataLayer = {
  attach: function(context, settings) {
    let gtmLoaded = false;
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}

      // Prepare cookie variables
      let domain = document.location.hostname;
      let path = drupalSettings.path.baseUrl;
      const cookieApi = window.Cookies;

      function setConsentCookie(name, value) {
        if (cookieApi && typeof cookieApi.set === 'function') {
          cookieApi.set(name, value, { path: path, domain: domain, sameSite: 'strict' });
          return;
        }

        // Fallback if js-cookie is not available.
        document.cookie = `${name}=${encodeURIComponent(String(value))}; path=${path}; SameSite=Strict`;
      }

      let statisticsAreAccepted = Drupal.behaviors.klaroConsentsToDataLayer.getKlaroConsent()?.statistik;
      let marketingIsAccepted = Drupal.behaviors.klaroConsentsToDataLayer.getKlaroConsent()?.marknadsforing;

      // If the current user has agreed to cookies and marketing is accepted...
      if (marketingIsAccepted) {
        // Set cookie
        setConsentCookie('rlx-marketing', true);
      } else {
        // If not accepted...
        setConsentCookie('rlx-marketing', false);
      }

       // If the current user has agreed to cookies and statistics is accepted...
      if (statisticsAreAccepted) {
        // Set cookie
        setConsentCookie('rlx-consent', true);
      } else {
        // If not accepted...
        setConsentCookie('rlx-consent', false);
      }

      // Create rolex cookies directly on the change event without a page load
      document.addEventListener('klaro.consent_changed', function (event) {
        let statisticsAreAccepted = Drupal.behaviors.klaroConsentsToDataLayer.getKlaroConsent()?.statistik;
        let marketingIsAccepted = Drupal.behaviors.klaroConsentsToDataLayer.getKlaroConsent()?.marknadsforing;

        setConsentCookie('rlx-consent', statisticsAreAccepted);
        setConsentCookie('rlx-marketing', marketingIsAccepted);
      });

    function loadGTMScript() {
      if (gtmLoaded) return;

      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
        let f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),
            dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window, document, 'script', 'dataLayer', 'GTM-W2Q3NHF');

      gtmLoaded = true;
    }

    // Initialize and start polling immediately
    let lastConsent = null;

    function handleConsentChange(consents) {
      // Load the GTM script if statistics or marketing consent is granted.
      if (consents && (consents['statistik'] || consents['marknadsforing'])) {
        loadGTMScript();
      }

      if (consents) {
        gtag('consent', 'update', {
          analytics_storage: consents['statistik'] ? 'granted' : 'denied',
          ad_storage: consents['marknadsforing'] ? 'granted' : 'denied',
          ad_user_data: consents['marknadsforing'] ? 'granted' : 'denied',
          ad_personalization: consents['marknadsforing'] ? 'granted' : 'denied',
          functionality_storage: consents['funktionella'] ? 'granted' : 'denied',
          personalization_storage: consents['funktionella'] ? 'granted' : 'denied',
          security_storage: 'granted'
        });
      }
    }

    function pollForChanges() {
      let currentConsent = getKlaroConsent();
      let currentConsentString = JSON.stringify(currentConsent);
      let lastConsentString = JSON.stringify(lastConsent);

      if (currentConsentString !== lastConsentString) {
        console.log('Consent changed from', lastConsent, 'to', currentConsent);

        // Call handleConsentChange on any change.
        handleConsentChange(currentConsent);

        // Trigger consent changed event for external scripts.
        const consentChangeEvent = new CustomEvent("klaro.consent_changed", { detail: currentConsent });
        document.dispatchEvent(consentChangeEvent);

        // Update dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'klaro_consent_update',
          'klaro_consents': currentConsent
        });

        lastConsent = currentConsent;
      }
    }

    // Check for existing consent on page load and handle it.
    let existingConsent = getKlaroConsent();
    if (existingConsent) {
      handleConsentChange(existingConsent);
      lastConsent = existingConsent;
    }

    // Check immediately on page load.
    pollForChanges();

    // Poll every 500ms for changes.
    setInterval(pollForChanges, 500);
  }
};


function getKlaroConsent() {
  let match = document.cookie.match(/klaro=([^;]+)/);
  if (match) {
    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      console.warn('Could not parse Klaro cookie:', e);
    }
  }
  return null;
}
Drupal.behaviors.klaroConsentsToDataLayer.getKlaroConsent = getKlaroConsent;
